/**
 * @generated SignedSource<<9b13ad06f6919f10484f11e6569b9fab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganisationRoleType = "ADMIN" | "DEVELOPER" | "WORKSPACE_USER";
export type OrgUsersQuery$variables = Record<PropertyKey, never>;
export type OrgUsersQuery$data = {
  readonly organisation: {
    readonly id: string;
    readonly name: string;
    readonly users: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly orgRole: OrganisationRoleType;
          readonly user: {
            readonly email: string;
            readonly id: string;
            readonly name: string;
          };
        };
      }>;
    };
  };
};
export type OrgUsersQuery = {
  response: OrgUsersQuery$data;
  variables: OrgUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgUserConnection",
      "kind": "LinkedField",
      "name": "users",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrgUserEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgUser",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "orgRole",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgUsersQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v2/*: any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgUsersQuery",
    "selections": [
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "d78a72dc3ca38610068ac32e3860be39",
    "id": null,
    "metadata": {},
    "name": "OrgUsersQuery",
    "operationKind": "query",
    "text": "query OrgUsersQuery {\n  organisation {\n    id\n    name\n    users {\n      edges {\n        node {\n          user {\n            id\n            name\n            email\n          }\n          orgRole\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbc1bcb8b7003a765fa1824199e127cb";

export default node;
